import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../core/http.service';
import { GlobalsService } from '../globals.service';
import { Observable } from 'rxjs';
import { Advertiser } from 'src/app/models/services/audiences/dv360/advertiser';
import { Audience } from 'src/app/models/services/audiences/dv360/audience';
import { Partner } from 'src/app/models/services/audiences/dv360/partner';

@Injectable({
  providedIn: 'root'
})
export class DV360AudiencesService {

  constructor(
    private httpService: HttpService,
    private globalsService: GlobalsService
  ) { }

  public getPartners(): Observable<Partner[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/target-platforms/dv360/partners`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }

  public getAdvertisers(partnerId: string): Observable<Advertiser[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/target-platforms/dv360/partners/${partnerId}/advertisers`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  }

  public getAudiences(advertiserId: string): Observable<Audience[]> {
    let url: string = `${environment.audiencesServicesApiBaseUri}/target-platforms/dv360/partners/advertisers/${advertiserId}/audiences`;
    return this.httpService.get(url, this.globalsService.getActiveCompany()?.id);
  } 

}